/**
 * Add a collapse button
 */
var CollapseButton = /** @class */ (function () {
    function CollapseButton() {
        var _this = this;
        this.button = document.getElementById("collapsedButton");
        this.button.addEventListener("click", function (event) {
            _this.collapse();
        });
        if (window.location.href.includes("results")) {
            var panel = document.getElementsByClassName("panel-collapse");
            panel[0].classList.add('collapsed');
        }
        if (!window.location.href.includes("results") && screen.width >= 1280) {
            this.button.style.display = "none";
        }
        if (window.screen.width <= 960) {
            document.getElementById("icon-collapse").classList.add("fa-chevron-up");
            document
                .getElementById("icon-collapse")
                .classList.remove("fa-chevron-left");
        }
    }
    CollapseButton.prototype.collapse = function () {
        var panel = document.getElementsByClassName("panel-collapse");
        if (panel[0].classList.contains("collapsed")) {
            panel[0].classList.remove("collapsed");
            if (window.screen.width <= 960) {
                document
                    .getElementById("icon-collapse")
                    .classList.add("fa-chevron-up");
                document
                    .getElementById("icon-collapse")
                    .classList.remove("fa-chevron-down");
            }
            else {
                document
                    .getElementById("icon-collapse")
                    .classList.add("fa-chevron-left");
                document
                    .getElementById("icon-collapse")
                    .classList.remove("fa-chevron-right");
            }
        }
        else {
            panel[0].classList.add("collapsed");
            if (window.screen.width <= 960) {
                document
                    .getElementById("icon-collapse")
                    .classList.add("fa-chevron-down");
                document
                    .getElementById("icon-collapse")
                    .classList.remove("fa-chevron-up");
            }
            else {
                document
                    .getElementById("icon-collapse")
                    .classList.add("fa-chevron-right");
                document
                    .getElementById("icon-collapse")
                    .classList.remove("fa-chevron-left");
            }
        }
    };
    return CollapseButton;
}());
export { CollapseButton };
